import { MapContainer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useEffect, useMemo, useState } from "react";
import { LatLngExpression } from "leaflet";
import DemoDeviceLayer from "./DemoDeviceLayer";

function AddGoogleMapsLayer({ layer }: { layer: L.TileLayer }) {
  const map = useMap();
  useEffect(() => {
    layer.addTo(map);
    return () => { layer.removeFrom(map); };
  }, [map]);
  return null;
}

const MapView = () => {
  const position: LatLngExpression = [20.1311504495924, 85.1703809925077];

  const googleHybrid = useMemo(
    () => L.tileLayer("http://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}", {
      maxZoom: 20,
      subdomains: ["mt0", "mt1", "mt2", "mt3"],
    }),
    []
  );

  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <MapContainer
        center={position}
        zoom={13}
        scrollWheelZoom
        style={{ height: "calc(100vh - 80px)", minHeight: "100vh" }}
      >
        <AddGoogleMapsLayer layer={googleHybrid} />
        <DemoDeviceLayer />
      </MapContainer>
    </div>
  );
};

export default MapView;